






































import { Component, Mixins } from "vue-property-decorator";
import { TextObjectKinds } from "../../../../../../documaker/domain/format/objects";
import { StandardTextDrawableObjectDrawerBase } from "./base";
import {
  FreeInputBehaviorPropertyEditableMixin,
  HisInformationKeyPropertyEditableMixin,
  UserDefinedInformationKeyPropertyEditableMixin,
  RangeOfMotionGroupKeyPropertyEditableMixin,
} from "../../mixins";
import { ObjectKeys } from "../../../../../domain/configuration";
import { TextObjectEditor } from "../../../../../domain/editableFormat/objectEditors";
import { default as TextAreaRectangleCoordinatableObjectEditor } from "./TextAreaRectangleCoordinatableObjectEditor.vue";
import { default as InputRectangleCoordinatableObjectEditor } from "./InputRectangleCoordinatableObjectEditor.vue";
import { default as NamedRectangleCoordinatableObjectDrawer } from "./NamedRectangleCoordinatableObjectDrawer.vue";

@Component({
  components: {
    TextAreaRectangleCoordinatableObjectEditor,
    InputRectangleCoordinatableObjectEditor,
    NamedRectangleCoordinatableObjectDrawer,
  },
})
export default class TextObjectDrawer extends Mixins(
  StandardTextDrawableObjectDrawerBase,
  FreeInputBehaviorPropertyEditableMixin,
  HisInformationKeyPropertyEditableMixin,
  UserDefinedInformationKeyPropertyEditableMixin,
  RangeOfMotionGroupKeyPropertyEditableMixin) {
  readPropertyOrDefault: <T>(reader: (source: TextObjectEditor) => T, defaultValue: T) => T;

  get shouldShowTextArea(): boolean {
    switch (this.objectKind) {
      case TextObjectKinds.Free:
      case TextObjectKinds.Fixed:
        return true;
      default:
        return false;
    }
  }

  get shouldShowInput(): boolean {
    switch (this.objectKind) {
      case TextObjectKinds.Number:
        return true;
      default:
        return false;
    }
  }

  get readonly(): boolean {
    switch (this.objectKind) {
      case TextObjectKinds.Free:
      case TextObjectKinds.Number:
        // TODO: 文書内転記(text-paste)されている場合はfalseで返す
        return !this.freeInputBehavior.isEnable;
      default:
        return false;
    }
  }

  get displayName(): string {
    switch (this.objectKind) {
      case TextObjectKinds.HisItem:
        return this.hisInformationName;
      case TextObjectKinds.UserDefined:
        return this.userDefinedInformationName;
      case TextObjectKinds.DesignatedDoctorNumber:
        return "指定医番号";  // 本来はinformationKeyを出すべき？
      case TextObjectKinds.RangeOfMotion:
        return " "; // 関節可動域オブジェクトのテキストは、スペースを入力して無地のボックスを表示。
      default:
        return "";
    }
  }

  get configurationKey(): ObjectKeys {
    switch (this.objectKind) {
      case TextObjectKinds.Free:
        return "FreeText";
      case TextObjectKinds.Fixed:
        return "FixedText";
      case TextObjectKinds.Number:
        return "NumberText";
      case TextObjectKinds.HisItem:
        return "HisText";
      case TextObjectKinds.UserDefined:
        return "UserDefinedText";
      case TextObjectKinds.DesignatedDoctorNumber:
        return "DesignatedDoctorNumberText";
      case TextObjectKinds.RangeOfMotion:
        return "RangeOfMotionText";
      default:
        return "NotImplemented";
    }
  }

  get objectKind(): TextObjectKinds {
    return this.readPropertyOrDefault(s => s.objectKind().getValue(), TextObjectKinds.Free);
  }

  restriction(value: string): boolean {
    switch (this.objectKind) {
      case TextObjectKinds.Number:
        return /^-?[\d,\.]*$/.test(value);
      default:
        return true;
    }
  }

  validate(value: string): boolean {
    switch (this.objectKind) {
      case TextObjectKinds.Number:
        // TODO: 上限値や下限値が設定されている場合、チェックする。範囲外は警告を出す
        return value === "" || !isNaN(parseFloat(value));
      default:
        return true;
    }
  }
}
